import { CommitmentGoalLookup } from '../pillar-one/commitment-goal-lookup.model';

import { AllowedActions } from './allowed-actions.model';
import { CommitmentCategory } from './commitment-category.model';
import { CommitmentStatusesView } from './commitment-status-view.model';
import { LocationView } from './location-view.model';
import { ObservationCategory } from './observation-category.model';
import { ObservationStatusesView } from './observation-status.model';

export interface PillarTwoState {
    pending: {
        reload?: boolean;
        reloadCommitments?: boolean;
        reloadObservations?: boolean;
    };

    allowedActions?: AllowedActions;

    /** current selected/active metric */
    metricId?: number;

    location: LocationView;

    /** status state for commitments */
    commitmentStatuses?: CommitmentStatusesView;

    /** active state for observations */
    observationStatuses?: ObservationStatusesView;

    // TODO revise. logic is borrowed from pillar-one
    commitmentGoalLookup?: CommitmentGoalLookup;
    metricIdIsInMultiple?: boolean;

    /**
     * static order:
     * - active-with-metric
     * - other-active
     * - draft
     * - closed
     * - disputed
     */
    commitmentCategories?: CommitmentCategory[];

    /**
     * static order:
     * - published-for-this-metric
     * - draft-for-this-metric
     * - published-for-other-metrics
     * - draft for other metrics
     * - draft unfocused
     */
    observationCategories?: ObservationCategory[];
}

export const defaultState = (): PillarTwoState => ({
    pending: {},
    location: {},
});
